export const stateName = 'home';